export const hasPermission = (roleList: string[] = [], route?: string) => {
  // const godMode = localStorage.getItem("god_mode");

  // if (
  //   godMode === "true" &&
  //   (route?.includes("menu") || route?.includes("Menu"))
  // ) {
  //   return true;
  // }

  const username = localStorage.getItem("username");

  const userRoles = JSON.parse(localStorage.getItem("userRole") || "[]") || "";
  const hasAccess = userRoles.some((i: any) => roleList.includes(i));

  if (!userRoles) {
    return false;
  }

  if (
    route?.includes("analytics") &&
    username &&
    userRoles.includes("Location-manager")
  )
    return hasAccess && username === "bahandi.manager";
  return hasAccess;
};
